//-----------------------------------------------------------------------
// DOCUMENT READY
//-----------------------------------------------------------------------
$(document).ready(function () {
    $(document).on('click', '.tab-label', function (e) {
        $(".tab-label").removeClass("active-tab");
        $(this).addClass("active-tab");
    });
});